<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Logs"
        :help="true"
        titleHelp="Ajuda - Logs"
        content="Tela responsável por pesquisar ações de usuários no Sistema, possibilitando pesquisa com filtros.">
      </page-title>
      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Usuário</label>
            <multiselect
              placeholder="Selecione o usuário"
              v-model="filter.whodunnit"
              :options="users"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="name"
              track-by="id"
              @search-change="getUsers"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Módulo</label>
            <multiselect
              v-model="filter.itemType"
              :options="itemTypes"
              label="translation"
              placeholder="Selecionar Módulo"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="value"
            />
          </div>

          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Ação</label>
            <multiselect
              v-model="filter.event"
              :options="events"
              placeholder="Selecione a ação"
              label="translation"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="value"
              :show-no-options="false"
            />
          </div>

          <div class="col-6">
            <label class="form-control-label d-block mb-2 mt-3"
              >A partir de</label
            >
            <el-date-picker
              v-model="filter.startDate"
              type="date"
              placeholder="Data início"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
            />
          </div>
          <div class="col-6">
            <label class="form-control-label d-block mb-2 mt-3">Até</label>
            <el-date-picker
              v-model="filter.endDate"
              type="date"
              placeholder="Data Fim"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="primary" @click="generateReport" v-loading="isLoading"
            >Consulta</base-button
          >
        </div>
      </card>

      <!-- Consulta -->
      <card v-show="versions.length" v-loading="isLoading" ref="report">
        <collapse
          class="commercial-card card mt-2"
          :multipleActive="false"
        >
          <div slot="title">
            <h4 class="mb-0">
              das
            </h4>
          </div>
          <div class="row">
            <div class="col-6">
              <h2> Modelo </h2>
            </div>
            <div class="col-6">
              <h2> Data </h2>
            </div>
          </div>
          <collapse-item v-for="version in versions" :key="version.id" >
            <div slot="title">
              <div class="row">
                <div class="col-6">
                  {{ version.item_type }}
                </div>
                <div>
                  <i class="fa fa-clock"></i>
                  {{ version.created_at }}
                </div>
              </div>
            </div>
            <div >
              <div class="col hide-on-print">
                <h5 class="text-uppercase text-muted ls-1 h3 mb-0">
                  Evento - {{ version.event }}
                </h5>
              </div>

              <div v-if="version.event == 'Atualização'">
                <el-table :data="version.changes_to_json" >
                  <el-table-column label="Responsável"      prop="user_name" min-width="220" sortable v-slot="{ row }">
                    {{ row.user_name }}
                  </el-table-column>
                  <el-table-column label="Nome do Atributo" prop="name" min-width="220" sortable v-slot="{ row }">
                    {{ row.name }}
                  </el-table-column>
                  <el-table-column label="Estado Prévio"    prop="previousValue" min-width="220" sortable v-slot="{ row }">
                    {{ row.previousValue }}
                  </el-table-column>
                  <el-table-column label="Estado Posterior" prop="nextValue" min-width="220" sortable v-slot="{ row }">
                    {{ row.nextValue }}
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="version.event == 'Criação'">
                <el-table :data="version.changes_to_json" >
                  <el-table-column label="Responsável"      prop="user_name" min-width="220" sortable v-slot="{ row }">
                    {{ row.user_name }}
                  </el-table-column>
                  <el-table-column label="Nome do Atributo" prop="name" min-width="220" sortable v-slot="{ row }">
                    {{ row.name }}
                  </el-table-column>
                  <el-table-column label="Valor"            prop="previousValue" min-width="220" sortable v-slot="{ row }">
                    {{ row.nextValue }}
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="version.event == 'Exclusão'">
                <el-table :data="version.changes_to_json" >
                  <el-table-column label="Responsável"      prop="user_name" min-width="220" sortable v-slot="{ row }">
                    {{ row.user_name }}
                  </el-table-column>
                  <el-table-column label="Nome do Atributo" prop="name" min-width="220" sortable v-slot="{ row }">
                    {{ row.name }}
                  </el-table-column>
                  <el-table-column label="Removido"         prop="previousValue" min-width="220" sortable v-slot="{ row }">
                    {{ row.previousValue }}
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </collapse-item>
      </collapse>
      </card>
    </div>
    <div slot="footer" class="py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      filter: {
        whodunnit: null,
        itemType: null,
        event: null,
        startDate: "",
        endDate: "",
      },
      users: [],
      itemTypes: [],
      events: [],
      versions: [],
      paginated_data: [],
      lastEdition: new Date(),
      isLoading: false,
    };
  },
  methods: {
    async generateReport(page) {
      if (this.filter.startDate > this.filter.endDate) {
        this.$toasted.global.defaultWarnig({msg: "Data de início não pode ser maior que a data final"});
      return;
      }
      this.isLoading = true
      try {
      const response = await this.$http.secured
        .get("/api/v1/report/versions", {
          params: {
            "version[whodunnit]": this.filter.whodunnit
              ? this.filter.whodunnit.id
              : null,
            "version[item_type]": this.filter.itemType
              ? this.filter.itemType.value
              : null,
            "version[event]": this.filter.event
              ? this.filter.event.value
              : null,
            "version[start_date]": this.filter.startDate
              ? this.filter.startDate
              : null,
            "version[end_date]": this.filter.endDate
              ? this.filter.endDate
              : null,
              page: page
          },
        })
        this.paginated_data = response.data;
        this.versions = response.data = this.paginated_data["versions"];
        if (this.versions.length == 0) this.isLoading = false;
        this.transformToJson()
      }
      catch(error) {console.log(error)}
    },
    initData() {
      this.$http.secured.get("/api/v1/report/versions", { params: { data: true } })
        .then((response) => {
          console.log(response)
          console.log(response.data)
          this.events = response.data.events;
          this.itemTypes = response.data.item_types;
        });
    },
    transformToJson() {
      this.versions.map((version) => {
        if (version.changes_to_json) {
          length = Object.keys(version.changes_to_json).length
          this.objectChanges = []
          for (let index = 0; index < length; index++) {
            let obj = {}
            const name = Object.keys(version.changes_to_json)[index]

            if ( version.changes_to_json[name][0] && version.changes_to_json[name][1] ) {     // update
              obj.previousValue = version.changes_to_json[name][0]
              obj.nextValue     = version.changes_to_json[name][1]
            }
            else if ( version.changes_to_json[name][0] && !version.changes_to_json[name][1] ) // destroy
              obj.previousValue = version.changes_to_json[name][0]

            else obj.nextValue = version.changes_to_json[name][1]                             // create

            obj.name = name
            obj.user_name     = version.user_name
            this.objectChanges.push(obj)
          }
          version.changes_to_json = this.objectChanges
        }
        this.lastEdition = new Date();
        this.isLoading = false;
      })
    },
    getUsers(query) {
      var data = {
        per_page: 10,
        q: { name: query, status: true },
      }
      this.$http.secured
      .get("/api/v1/users", { params: data })
      .then(response => ( this.users = response.data.users ))
      .catch(error => console.log(error, "Something went wrong"))
    },
    changePage(page) {
      this.generateReport(page);
    },
    clearFilters() {
      this.filter.whodunnit = null,
      this.filter.itemType = null,
      this.filter.event = null,
      this.filter.startDate = ""
      this.filter.endDate = ""
    },
  },
  mounted() {
    this.getUsers();
    this.initData();
  },
};
</script>

<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
